import { useUserData } from '@lib/userData/UserDataProvider';
import { FlexColPageContainer } from '../../components/FlexColPageContainer';
import { LogoutButton } from '../../features/auth';

export const metadata = {
  title: 'Profile | Patchooli',
  description: 'Profile | Patchooli',
};

export const ProfilePage = () => {
  const [userData] = useUserData();
  // const photoURL = userData?.profile?.photoURL;
  const firstName = userData?.profile?.firstName;
  return (
    <FlexColPageContainer>
      <div className="mx-auto max-w-md">
        <h1 className="text-2xl font-bold">Profile</h1>
      </div>
      <div className="flex flex-col items-center">
        <h2 className="text-xl font-bold">{firstName}</h2>
      </div>
      {/* {photoURL && (
        <Image
          src={photoURL}
          alt={`photo of ${firstName}`}
          className="h-24 w-24 rounded-full"
          width={96}
          height={96}
        />
      )} */}

      <LogoutButton />
    </FlexColPageContainer>
  );
};
